import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "ads-checkboxlist",
  templateUrl: "./checkboxlist.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxlistComponent,
      multi: true,
    },
  ],
})
export class CheckboxlistComponent implements ControlValueAccessor, OnChanges {


  private onChange: (value: any) => void;
  public onTouched: () => void;

  @Input("data") datasource: Array<any> = [];
  @Input() orientation: string = "horizontal";
  @Input() valuefield: string = "";
  @Input() textfield: string = "";
  @Input() name: string = "";
  @Input("disabled") isdisabled: boolean = false;
  @Input("helpText") helpText: string;
  @Input("hintText") hintText: string;
  @Input("isprimitive") isprimitiveSelection: boolean = false;
  checkedItems: Array<any> = [];


  public get isPrimitiveDatasource(): boolean {
    /**
     * here we are checking the original datasource because in the backup datasource - even the pritive array is converted to the complex array
     * to hold check /uncheck values
     */
    return typeof (this.datasource[0]) === "string" || typeof (this.datasource[0]) === "number";//&& this.valuefield !== "" && this.textfield !== "";
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isdisabled = isDisabled;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.updateCheckFlagInDS();
  }
  writeValue(obj: any): void {
    if (obj) {
      this.checkedItems = obj;
      this.updateCheckFlagInDS();
    }
  }
  bckupdatasource: Array<any> = [];
  updateCheckFlagInDS() {
    this.bckupdatasource = [];
    // STEP:1  Take backup of datasource to use internally -
    if (this.datasource) {
      this.bckupdatasource = JSON.parse(JSON.stringify(this.datasource));
    }
    //STEP 2: add checked property to show check /uncheck
    //if datasouce is complex then add 'checked' property and  assign the false initially
    if (typeof (this.bckupdatasource[0]) == "object") {
      this.bckupdatasource.forEach(item => {
        item["checked"] = false;
      })
    } else if (typeof (this.bckupdatasource[0]) === "string" || typeof (this.bckupdatasource[0]) === "number") {

      //if the datasource is complex then create an array of object with value and checked as properties
      //and assign the false value to the checked attr
      let mappedComplexArray = this.bckupdatasource.map((e) => {
        return { value: e, checked: false };
      });
      this.bckupdatasource = JSON.parse(JSON.stringify(mappedComplexArray));

    }
    // STEP 3: based on the ngModel array set the value of checked as true
    if ((this.isprimitiveSelection && !this.isPrimitiveDatasource)) {
      this.checkedItems.forEach((checkeditem: string | number) => {
        // till this point the pritive ds will converted as complex array from above mapping
        let index = this.bckupdatasource.findIndex((itemInMainDs: any) => itemInMainDs[this.valuefield] === checkeditem);
        this.bckupdatasource[index]['checked'] = true;

      });
    } else if (this.isprimitiveSelection && this.isPrimitiveDatasource) {
      {
        this.checkedItems.forEach((checkeditem: string | number) => {
          // till this point the pritive ds will converted as complex array from above mapping
          let index = this.bckupdatasource.findIndex((itemInMainDs: any) => itemInMainDs["value"] === checkeditem);
          this.bckupdatasource[index]['checked'] = true;
        });
      }
    } else if (!this.isprimitiveSelection && !this.isPrimitiveDatasource) {
      {
        this.checkedItems.forEach((checkeditem: string | number) => {
          // till this point the pritive ds will converted as complex array from above mapping
          let index = this.bckupdatasource.findIndex((itemInMainDs: any) => itemInMainDs[this.valuefield] === checkeditem[this.valuefield]);
          this.bckupdatasource[index]['checked'] = true;
        });
      }
    }
  }



  onItemClick(item: any) {
    /*
    here we are already setting /resetting the checked flag value in the html template and
    by the way of two way data binidng it will reflect in the bckupDatasource as well
    */
    let filterItems = this.bckupdatasource.filter(item => item.checked);
    if (this.isprimitiveSelection) {
      this.checkedItems = [];
      if (this.isPrimitiveDatasource)
        filterItems.forEach(item => {
          this.checkedItems.push(item["value"]);
        });
      else
        filterItems.forEach(item => {
          this.checkedItems.push(item[this.valuefield]);
        });
      this.onChange(this.checkedItems);
    } else {
      // filterItems.forEach(item => {
      //   delete item['checked'];
      // });
      this.checkedItems = filterItems;
      this.onChange(this.checkedItems);
    }


  }
  gethelpClass() {
    if (this.helpText == "" || this.helpText == undefined) {
      return {
        "vm-help-icon-inline": false,
      };
    } else {
      return {
        "vm-help-icon-inline": true,
      };
    }
  }
  gethintClass() {
    if (this.hintText == "" || this.hintText == undefined) {
      return {
        "vm-hint-inline text-muted": false,
      };
    } else {
      return {
        "vm-hint-inline text-muted": true,
      };
    }
  }

}
